import axios from "axios";
import { ClearSession, GetSession } from "../../Shared-ui/utils/Auth/AuthHelpers";
import { BaseUrl, MetaBaseUrl } from "../../Constant/Setting";
import { useDispatch, useSelector } from "react-redux";
import { SetLogout } from "../../Shared-ui/Store/AuthReducer/AuthActions";
import { redirect } from "react-router-dom";
import { ShowError } from "../../Shared-ui/Store/MessageReducer/MsgActions";
import Store from "../../Shared-ui/Store";

const BaseMultipartInstance = axios.create({
    baseURL: BaseUrl,
    headers: {
        'Content-Type': 'multipart/form-data',
    }
})

// Set up an Axios request interceptor to add the authorization token

BaseMultipartInstance.interceptors.request.use((config) => {
    const serviceToken = GetSession()
    if (serviceToken) {
        config.headers['Authorization'] = `Bearer ${serviceToken}`;
    }
    return config
}, (error) => {
    return Promise.reject(error)
})

// Set up an Axios response interceptor to handle authentication errors and logout

BaseMultipartInstance.interceptors.response.use((response) => {
    return response
}, (error) => {
    if (error.response) {
        if (error.response.status === 401 || error.response.status === 403) {
            ClearSession()
            window.location.href = "/logout"
        } else if (error.response.status === 400) {
            Store.dispatch(ShowError(error?.response?.data?.detail, 3000))
        } else {
            return Promise.reject(error)
        }
    }
    return Promise.reject(error)
})

export default BaseMultipartInstance